import React, { useState } from 'react';
import {
  Box,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Divider,
} from '@mui/material';
import {
  KeyboardArrowDown as ArrowDownIcon,
  Public as GlobeIcon,
} from '@mui/icons-material';
import { useApp, Markets } from '../../context/AppContext';

const marketOptions = [
  { code: 'ALL', name: 'All Markets', flag: '🇪🇺', color: '#00d4ff' },
  { code: 'GB', name: 'Great Britain', flag: '🇬🇧', color: '#e74c3c' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪', color: '#f1c40f' },
  { code: 'IE', name: 'Ireland', flag: '🇮🇪', color: '#2ecc71' },
];

export default function MarketSelector() {
  const { state, actions } = useApp();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const selectedMarket = marketOptions.find(m => m.code === state.selectedMarket) || marketOptions[0];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (code) => {
    actions.setMarket(code);
    handleClose();
  };

  return (
    <>
      <Button
        onClick={handleClick}
        endIcon={<ArrowDownIcon />}
        sx={{
          px: 1.5,
          py: 0.75,
          borderRadius: 2,
          backgroundColor: 'rgba(255,255,255,0.05)',
          border: `1px solid ${selectedMarket.color}40`,
          color: 'white',
          textTransform: 'none',
          minWidth: 'auto',
          '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.08)',
            borderColor: `${selectedMarket.color}80`,
          },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography sx={{ fontSize: '1.1rem' }}>{selectedMarket.flag}</Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              display: { xs: 'none', sm: 'block' },
            }}
          >
            {selectedMarket.code === 'ALL' ? 'All' : selectedMarket.code}
          </Typography>
        </Box>
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            backgroundColor: '#1a1a2e',
            border: '1px solid rgba(0, 212, 255, 0.2)',
            borderRadius: 2,
            minWidth: 180,
          },
        }}
      >
        <Typography
          sx={{
            px: 2,
            py: 1,
            fontSize: '0.7rem',
            fontWeight: 600,
            color: 'rgba(255,255,255,0.5)',
            textTransform: 'uppercase',
            letterSpacing: 0.5,
          }}
        >
          Select Market
        </Typography>
        <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)' }} />

        {marketOptions.map((market) => (
          <MenuItem
            key={market.code}
            onClick={() => handleSelect(market.code)}
            selected={state.selectedMarket === market.code}
            sx={{
              py: 1,
              px: 2,
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.05)',
              },
              '&.Mui-selected': {
                backgroundColor: `${market.color}15`,
                borderLeft: `3px solid ${market.color}`,
                '&:hover': {
                  backgroundColor: `${market.color}20`,
                },
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 36 }}>
              <Typography sx={{ fontSize: '1.25rem' }}>{market.flag}</Typography>
            </ListItemIcon>
            <ListItemText
              primary={market.name}
              primaryTypographyProps={{
                variant: 'body2',
                color: state.selectedMarket === market.code ? market.color : 'rgba(255,255,255,0.9)',
                fontWeight: state.selectedMarket === market.code ? 600 : 400,
              }}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
